// extracted by mini-css-extract-plugin
export default {"root":"root___p61Cc","block":"block___cP3ga"};